module.exports = __webpack_public_path__ + "ad74ea384.png";